import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './styles/theme';
import Root from './routes';
// import './index.css';
// import * as serviceWorker from './serviceWorker'

ReactDOM.render(<Root />, document.getElementById('root'));

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {/* <React.StrictMode> */}
    <Root />
    {/* </React.StrictMode> */}
  </ThemeProvider>,
  document.querySelector('#root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();
